
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import MainButton from "../../../../common/MainButton";
import AppStoreButton from "../../../../common/AppStoreButton";
import PlayMarketButton from "../../../../common/PlayMarketButton";
import Link from "next/link";
const Banner = ({ t }) => {
    const banner = t('coldware_finance:banner', {}, { returnObjects: true });
    return (<section className={'banner'}>
            <div className="container">
                <span className={'banner_label'}>{banner.label}</span>
                <div className="banner_wrapper">
                    <h1 className={'banner_title'}>
                        <span>{banner.title_1}
                            <picture>
                                <img src={`/img/pages/ecosystem/banner/token_icon.png`} alt={`ColdWare Wallet`} width={380} height={380} className='banner_title_icon'/>
                        </picture>
                        </span>
                        <span>{banner.title_2}</span>


                    </h1>
                    <div className={'banner_app'}>
                        <Link href={process.env.NEXT_PUBLIC_APP_URL}>
                            <MainButton title={banner.cta}/>
                        </Link>
                    </div>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__196924c9851__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/token/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196924c9851__ as getStaticProps }
  